import { TextField } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";

const emailValidation = new RegExp("^(([^<>()[\\]\\\\.,;:\\s@\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$", "i");

export class SwivuEmailField extends TextField {

  static get type() {
    return WIDGET_KEYS.fieldEmail;
  }

  static get configurable() {
    return {
      listeners: {
        change: ({ source, value }) => {
          source.value = value.trim();
        }
      }
    }
  }

  get isValid() {
    return super.isValid && (!this.value?.trim() || emailValidation.test(this.value.trim()));
  }
}

SwivuEmailField.initClass();
